import React from "react";
const ICON_COLOR = "#6C5DD3"; // matches screenshot
const DownloadIcon = ({ className = "w-4 h-4" }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
    >
        <path d="M12 3v12" />
        <path d="M7 10l5 5 5-5" />
        <path d="M5 21h14" />
    </svg>
);
const CheckIcon = ({ className = "w-4 h-4 text-green-500" }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
    >
        <circle cx="12" cy="12" r="10" strokeOpacity="0.2" />
        <path d="M8 12l3 3 5-5" />
    </svg>
);
const PrintIcon = ({ className = "w-4 h-4" }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
    >
        <path d="M6 9V4h12v5" />
        <rect x="6" y="14" width="12" height="6" />
        <path d="M6 14H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2" />
    </svg>
);
// const ScoreCard = ({ title, score, label, color }) => {
//   return (
//     <div className="bg-white rounded-xl p-5 shadow-sm border w-full">
//       <p className="text-xs font-medium text-gray-500 mb-3">{title}</p>

//       {/* Circle */}
//       <div className="flex flex-col items-center justify-center">
//         <div
//           className="w-20 h-20 rounded-full flex items-center justify-center text-xl font-semibold"
//           style={{
//             border: `6px solid ${color}`,
//             color: color,
//           }}
//         >
//           {score}
//         </div>

//         <p className="mt-3 text-sm font-semibold" style={{ color }}>
//           {label}
//         </p>
//       </div>
//     </div>
//   );
// };
const ScoreCard = ({ icon, title, score, label, color }) => {
    const radius = 32;
    const stroke = 6;
    const normalizedRadius = radius - stroke * 0.5;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset =
        circumference - (score / 100) * circumference;

    return (
        <div className="bg-white rounded-xl p-5 border shadow-sm flex flex-col items-center text-center">

            {/* Icon */}
            <div className="mb-2">{icon}</div>

            <p className="text-[11px] text-gray-500 mb-3">{title}</p>

            {/* Circular Progress */}
            <svg height={radius * 2} width={radius * 2}>
                <circle
                    stroke="#E5E7EB"
                    fill="transparent"
                    strokeWidth={stroke}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                />
                <circle
                    stroke={color}
                    fill="transparent"
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={`${circumference} ${circumference}`}
                    style={{ strokeDashoffset }}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                />
                <text
                    x="50%"
                    y="50%"
                    dy="0.3em"
                    textAnchor="middle"
                    className="text-sm font-semibold fill-gray-700"
                >
                    {score}
                </text>
            </svg>

            <p className="mt-2 text-sm font-semibold" style={{ color }}>
                {label}
            </p>
        </div>
    );
};

export const ThermometerIcon = ({ className = "w-5 h-5 text-purple-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <path d="M10 14.5V5a2 2 0 1 1 4 0v9.5a4 4 0 1 1-4 0Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
        <circle cx="12" cy="18" r="2" fill="currentColor" />
    </svg>
);
export const ShieldIcon = ({ className = "w-5 h-5 text-red-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <path
            d="M12 3l7 3v6c0 5-3.5 7.5-7 9-3.5-1.5-7-4-7-9V6l7-3Z"
            stroke="currentColor"
            strokeWidth="2"
        />
    </svg>
);
const HeartIcon = () => (
  <svg width="20" height="20" fill="none" stroke={ICON_COLOR} strokeWidth="1.8">
    <path d="M12 21s-6-4-9-8c-2-3 1-7 4-5 1 1 2 2 2 2s1-1 2-2c3-2 6 2 4 5-3 4-9 8-9 8z"/>
    <path d="M7 12h2l1-2 2 4 1-2h2"/>
  </svg>
);
export const StarIcon = ({ className = "w-5 h-5 text-purple-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <path
            d="M12 3l3 6 6 .9-4.5 4.3 1 6.3L12 17l-5.5 3.5 1-6.3L3 9.9 9 9l3-6Z"
            stroke="currentColor"
            strokeWidth="2"
        />
    </svg>
);
export const TargetIcon = ({ className = "w-5 h-5 text-green-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <circle cx="12" cy="12" r="8" stroke="currentColor" strokeWidth="2" />
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
        <circle cx="12" cy="12" r="1.5" fill="currentColor" />
    </svg>
);
export const CheckCircleIcon = ({ className = "w-4 h-4 text-green-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.15" />
        <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="2.5" />
    </svg>
);
export const InfoIcon = ({ className = "w-5 h-5 text-indigo-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
        <path d="M12 8h.01M11 12h2v4h-2z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
);
export const SymptomIcon = () => (
    <svg width="20" height="20" fill="none" stroke="#6C5DD3" strokeWidth="2">
        <path d="M10 2v6M10 22v-6M4.2 4.2l4.2 4.2M15.6 15.6l4.2 4.2M2 10h6M22 10h-6" />
    </svg>
);

export const RiskIcon = () => (
    <svg width="20" height="20" fill="none" stroke="#E5484D" strokeWidth="2">
        <path d="M12 9v4M12 17h.01" />
        <path d="M10.29 3.86l-7.4 12.8A2 2 0 004.6 20h14.8a2 2 0 001.71-3.34l-7.4-12.8a2 2 0 00-3.42 0z" />
    </svg>
);

export const QualityIcon = () => (
    <svg width="20" height="20" fill="none" stroke="#3A7AFE" strokeWidth="2">
        <path d="M12 21s-6-4.35-9-8.5C-1 7 4 2 8 5c2 2 4 2 4 2s2 0 4-2c4-3 9 2 5 7.5C18 16.65 12 21 12 21z" />
    </svg>
);

export const FireIcon = ({ className = "w-4 h-4 text-red-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <path d="M12 2s4 4 4 8a4 4 0 1 1-8 0c0-4 4-8 4-8Z"
            fill="currentColor"
        />
    </svg>
);
export const MoonIcon = ({ className = "w-4 h-4 text-purple-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8Z"
            fill="currentColor"
        />
    </svg>
);
export const BrainIcon = ({ className = "w-4 h-4 text-indigo-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <circle cx="12" cy="12" r="5" stroke="currentColor" strokeWidth="2" />
    </svg>
);
export const DropletIcon = ({ className = "w-4 h-4 text-blue-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <path d="M12 2C12 2 6 9 6 13a6 6 0 0 0 12 0c0-4-6-11-6-11Z"
            fill="currentColor"
        />
    </svg>
);
export const BoneIcon = ({ className = "w-4 h-4 text-green-500" }) => (
    <svg viewBox="0 0 24 24" fill="none" className={className}>
        <path d="M6 6c1-1 3-1 4 0l4 4c1 1 1 3 0 4s-3 1-4 0l-4-4c-1-1-1-3 0-4Z"
            stroke="currentColor"
            strokeWidth="2"
        />
    </svg>
);
const ActivityIcon = () => (
  <svg width="20" height="20" fill="none" stroke={ICON_COLOR} strokeWidth="1.8">
    <circle cx="10" cy="4" r="1.5"/>
    <path d="M6 9l3-2 2 2 2 1M6 9l-2 4M11 10l1 4"/>
  </svg>
);
export const HeartSmallIcon = ({ className = "w-4 h-4 text-orange-500" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M12 21s-6-4.35-9-8.5C1 9 3.5 5 7 5c2 0 3 1 5 3 2-2 3-3 5-3 3.5 0 6 4 4 7.5-3 4.15-9 8.5-9 8.5Z" />
    </svg>
);
const AgeIcon = () => (
  <svg width="20" height="20" fill="none" stroke={ICON_COLOR} strokeWidth="1.8">
    <rect x="3" y="4" width="12" height="11" rx="2"/>
    <path d="M3 7h12M6 2v4M12 2v4"/>
  </svg>
);
const FamilyIcon = () => (
  <svg width="20" height="20" fill="none" stroke={ICON_COLOR} strokeWidth="1.8">
    <circle cx="6" cy="7" r="2"/>
    <circle cx="12" cy="7" r="2"/>
    <path d="M3 14c0-2 2-3 3-3s3 1 3 3M9 14c0-2 2-3 3-3s3 1 3 3"/>
  </svg>
);



const StressIcon = () => (
  <svg  width="20" height="20" fill="none" stroke={ICON_COLOR} strokeWidth="1.8">
    <path d="M9 3a6 6 0 00-6 6c0 2 1 3 2 4v2h8v-2c1-1 2-2 2-4a6 6 0 00-6-6z"/>
    <path d="M9 7v2M9 11h.01"/>
  </svg>
);

const SmokingIcon = () => (
  <svg width="20" height="20" fill="none" stroke={ICON_COLOR} strokeWidth="1.8">
    <path d="M2 12h10M14 12h2"/>
    <path d="M16 10c1 1 1 3 0 4"/>
  </svg>
);

const HormoneIcon = () => (
  <svg width="20" height="20" fill="none" stroke={ICON_COLOR} strokeWidth="1.8">
    <rect x="3" y="7" width="12" height="4" rx="2"/>
    <path d="M9 7v4"/>
  </svg>
);
const MenoPauseResults = () => {
    const riskFactors = [
        { name: "Age (51 years)", score: 10, type: "high", icon: <AgeIcon /> },
        { name: "Family history of breast cancer", score: 10, type: "high", icon: <FamilyIcon /> },
        { name: "High blood pressure", score: 10, type: "high", icon: <HeartIcon /> },
        { name: "Low Physical Activity", score: 5, type: "medium", icon: <ActivityIcon /> },
        { name: "High stress level", score: 5, type: "medium", icon: <StressIcon /> },
        { name: "Smoking", score: 10, type: "high", icon: <SmokingIcon /> },
        { name: "Hormone therapy (not using)", score: 0, type: "neutral", icon: <HormoneIcon /> },
    ];
    return (
        <div className="min-h-screen bg-gradient-to-br from-teal-50 via-blue-50 to-sky-100 flex items-center justify-center px-4 py-10">
            <div className="w-full flex flex-col overflow-hidden"
                style={{
                    maxWidth: '1060px',
                    minHeight: '523px',
                    background: 'linear-gradient(135deg, #ffffff 0%, #E8EEFC 100%)',
                    borderRadius: '12px',
                    boxShadow: '0 6px 36px rgba(26, 50, 102, 0.09)',
                }}>
                <div className="p-6 bg-[#F5F6FA] min-h-screen">
                    {/* Header */}
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-xl font-semibold text-[#2C2F5B]">
                            Assessment Results
                        </h2>

                        <div className="flex gap-3">
                            <button className="flex items-center gap-2 px-4 py-2 border rounded-md text-sm bg-white">
                                <DownloadIcon />
                                Download Report
                            </button>
                            <button className="flex items-center gap-2 px-4 py-2 border rounded-md text-sm bg-white">
                                <PrintIcon /> Print Report
                            </button>
                        </div>
                    </div>

                    {/* Info Banner */}
                    <div className="bg-[#EEF2FF] border rounded-lg p-4 mb-6 flex justify-between items-center">
                        <p className="text-sm text-[#4B4F8A]">
                            This assessment is for care guidance and does not provide a medical diagnosis.
                        </p>

                        <img
                            src="https://cdn-icons-png.flaticon.com/512/4140/4140048.png"
                            alt="illustration"
                            className="w-16"
                        />
                    </div>

                    {/* Score Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">

                        <ScoreCard
                            icon={<SymptomIcon />}
                            title="SYMPTOM SEVERITY SCORE"
                            score={68}
                            label="Moderate"
                            color="#6C5DD3"
                        />

                        <ScoreCard
                            icon={<RiskIcon />}
                            title="CLINICAL RISK SCORE"
                            score={35}
                            label="High"
                            color="#E5484D"
                        />

                        <ScoreCard
                            icon={<QualityIcon />}
                            title="QUALITY OF LIFE SCORE"
                            score={62}
                            label="Moderate Impact"
                            color="#3A7AFE"
                        />

                        {/* Care Priority */}
                        <div className="bg-white rounded-xl p-5 border shadow-sm flex flex-col items-center text-center">
                            <StarIcon />
                            <p className="text-xs text-gray-500 mt-2">CARE PRIORITY</p>
                            <h3 className="text-2xl font-bold text-[#7C3AED] mt-1">HIGH</h3>

                            <p className="text-xs text-gray-500 mt-2 text-center px-2">
                                You may benefit from professional care and a personalized plan.
                            </p>

                            <button className="mt-3 bg-[#7C3AED] text-white px-4 py-2 rounded-md text-sm">
                                Book Specialist Consult
                            </button>
                        </div>

                        {/* Next Best Action */}
                        <div className="bg-white rounded-xl p-5 border shadow-sm">
                            <div className="flex items-center gap-2 mb-3">
                                <TargetIcon />
                                <p className="text-xs text-gray-500">NEXT BEST ACTION</p>
                            </div>

                            <ul className="space-y-2 text-sm">
                                {[
                                    "Book a Menopause Specialist Consultation",
                                    "Discuss treatment options",
                                    "Start personalized care plan",
                                    "Lifestyle & symptom management",
                                ].map((item, i) => (
                                    <li key={i} className="flex items-start gap-2 text-gray-600">
                                        <CheckIcon />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    {/* Bottom Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {/* Symptom Breakdown */}
                        <div className="bg-white p-5 rounded-xl border">
                            <h3 className="text-sm font-semibold mb-4">
                                SYMPTOM DOMAIN BREAKDOWN
                            </h3>
                            {[
                                { name: "Vasomotor Symptoms", score: 78, color: "bg-purple-500", icon: "🔥" },
                                { name: "Sleep & Fatigue", score: 72, color: "bg-indigo-400", icon: "🌙" },
                                { name: "Psychological", score: 65, color: "bg-pink-400", icon: "🧠" },
                            ].map((item, i) => (
                                <div key={i} className="mb-3">
                                    <div className="flex justify-between text-xs mb-1">
                                        <span className="flex items-center gap-2">
                                            <span>{item.icon}</span>
                                            {item.name}
                                        </span>
                                        <span>{item.score}</span>
                                    </div>

                                    <div className="w-full bg-gray-200 h-2 rounded">
                                        <div
                                            className={`${item.color} h-2 rounded`}
                                            style={{ width: `${item.score}%` }}
                                        />
                                    </div>
                                </div>
                            ))}

                        </div>

                        {/* Risk Factors */}
                        <div className="bg-white p-5 rounded-xl border">
                            <h3 className="text-sm font-semibold mb-4">
                                CLINICAL RISK FACTORS
                            </h3>
                            {riskFactors.map((item, i) => {
                                const color =
                                    item.type === "high"
                                        ? "text-red-500 bg-red-50"
                                        : item.type === "medium"
                                            ? "text-orange-500 bg-orange-50"
                                            : "text-gray-400 bg-gray-100";

                                return (
                                    <div key={i} className="flex justify-between items-center text-sm mb-3">

                                        {/* LEFT: icon + text */}
                                        <div className="flex items-center gap-2 text-gray-700">
                                            {item.icon}
                                            <span>{item.name}</span>
                                        </div>

                                        {/* RIGHT: score badge */}
                                        <span className={`px-2 py-0.5 rounded-md text-xs font-semibold ${color}`}>
                                            {item.score > 0 ? `+${item.score}` : item.score}
                                        </span>
                                    </div>
                                );
                            })}

                            <div className="mt-4 text-sm font-semibold text-red-500">
                                Total Score: 35 / 100
                            </div>
                        </div>

                        {/* Scoring Guide */}
                        <div className="bg-white p-5 rounded-xl border">
                            <h3 className="text-sm font-semibold mb-4">SCORING GUIDE</h3>

                            <div className="text-xs space-y-2">
                                <p><span className="text-green-500">0–24</span> Low</p>
                                <p><span className="text-yellow-500">25–49</span> Moderate</p>
                                <p><span className="text-red-500">50–100</span> High</p>
                            </div>
                        </div>
                    </div>

                    {/* Footer CTA */}
                    <div className="bg-white mt-6 p-5 rounded-xl border flex justify-between items-center">
                        <div>
                            <p className="text-sm font-semibold">Recommended Next Step</p>
                            <div>
                            <AgeIcon/>
                            <span className="ava-text-xs">
                                Book a consultation with a Menopause Specialist
                            </span>
                            <p className="ava-text-xs">
                                Get expert guidance and a personalized care plan.
                            </p>
                            </div>
                        </div>

                        <button className="bg-[#7C3AED] text-white px-5 py-2 rounded-md">
                            Book Now →
                        </button>
                    </div>
                </div>
            </div></div>
    );
};

export default MenoPauseResults;